import Translate from "@casino/legacy/client/shared/i18n/Translate";
import React from "react";

const AlreadyHaveAccountLinkBody: FC = ({ children }) => (
  <div className="flex gap-2 overflow-hidden flex-wrap justify-start items-center">
    <p className="text-sm leading-6 text-muted-foreground">
      <Translate id="general.already_have_an_account" />
    </p>
    {children}
  </div>
);

export default AlreadyHaveAccountLinkBody;
